import React, { useEffect } from 'react';

const WIDGET_SCRIPT_ID = 'lc-feedback-widget-script';
const WIDGET_SRC =
  process.env.REACT_APP_LC_WIDGET_SRC ||
  'https://ai-lab.lighthouse-canton.com/static/widget/lc-widget.js';

export default function LcFeedbackWidget({ email }: { email: string }) {
  useEffect(() => {
    if (!email || document.getElementById(WIDGET_SCRIPT_ID)) return;
    const script = document.createElement('script');
    script.id = WIDGET_SCRIPT_ID;
    script.src = WIDGET_SRC;
    script.defer = true;
    document.head.appendChild(script);
  }, [email]);

  if (!email) return null;
  return React.createElement('lc-feedback-widget', {
    'app-id': 'mrms',
    'user-email': email,
  });
}
